﻿import { useScopedField } from '@ngt/forms-core';
import { FC, useCallback, useEffect } from 'react';

const GetPrice: FC = () => {
    const {state: {value: formCost}} = useScopedField<number>("cost", {value: true});
    const {context: {setValue: setOwing}} = useScopedField<number>("amountOwing", {value: true});

    const price = useCallback(() => {
        return formCost ? formCost : 0;
    },[formCost]);

    useEffect(() => {
        setOwing(formCost!);
    }, [formCost, setOwing]);

    return (
        <>
            $
            {
                price()
            }
        </>
    );
}

export default GetPrice;